import { useTranslation } from 'react-i18next';
import { Badge } from '@cortex/web-design-system/components/ui/Badge';
import type { BdSectionStatus } from './bd-defs.js';

export interface BdStatusBadgeProps {
  /** 節の状態 */
  status: BdSectionStatus;
  /** 保存済みの行数。まだ無い節では null */
  count: number | null;
}

/**
 * 節の状態の札。保存済みは行数、0 行で保存した任意の節は「該当なし」、それ以外は「未保存」。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計の節の状態（行数・該当なし・未保存）を色つきの札で出す
 * @graph-connects none
 */
export function BdStatusBadge({ status, count }: BdStatusBadgeProps) {
  const { t } = useTranslation();
  if (status === 'saved') {
    return (
      <Badge size="sm" variant="success">
        {t('bd.status.rows', { count: count ?? 0 })}
      </Badge>
    );
  }
  if (status === 'notApplicable') {
    return (
      <Badge size="sm" variant="info">
        {t('bd.status.notApplicable')}
      </Badge>
    );
  }
  return <Badge size="sm">{t('bd.status.notSaved')}</Badge>;
}
